import { useGameListSocket } from '~/socket/gamelist';
import { oGameName2Api } from '~/common/js/gameAbout';

const { EMIT_GET_GAME_CONFIG } = useGameListSocket();

export const fnGetRingConfig = (()=>{
    let oResolvers = null;

    return ()=>{
        if (oResolvers){
            return oResolvers.promise;
        }
        oResolvers = Promise.withResolvers();
        EMIT_GET_GAME_CONFIG(
            {game: oGameName2Api.ringGame},
            (oData)=>{
                if (!oData || oData.error) {
                    console.error('查询游戏配置失败', oData); 
                    oResolvers.reject(new Error('查询游戏配置失败')); 
                    return;
                }
                oResolvers.resolve(oData.config); 
            },
        );
        return oResolvers.promise; 
    }
})();


